export const KEY_ESC = 27;
export const KEY_RIGHT = 39;
export const KEY_LEFT = 37;
